import { render, staticRenderFns } from "./ModelPublish.vue?vue&type=template&id=3de95a86&"
import script from "./ModelPublish.vue?vue&type=script&lang=ts&"
export * from "./ModelPublish.vue?vue&type=script&lang=ts&"
import style0 from "./ModelPublish.vue?vue&type=style&index=0&id=3de95a86&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/StratusCAD/StratusCAD/ModelPipelineClient/model-pipeline-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3de95a86')) {
      api.createRecord('3de95a86', component.options)
    } else {
      api.reload('3de95a86', component.options)
    }
    module.hot.accept("./ModelPublish.vue?vue&type=template&id=3de95a86&", function () {
      api.rerender('3de95a86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modelPublish/ModelPublish.vue"
export default component.exports